import { TAG_COLUMN } from '../../../../core/utils/constants/tags';

/**
 * Nom de l'attribut pour le type de colonne.
 */
export const ATTR_TYPE = 'type';

/**
 * Valeur par défaut pour le type de colonne.
 */
export const DEFAULT_COLUMN_TYPE = 'default';

/**
 * Préfixe commun pour les classes CSS de la colonne.
 */
const CLASS_PREFIX = TAG_COLUMN;

/**
 * Classe CSS pour l'en-tête de la colonne.
 */
const CLASS_HEADER = `${CLASS_PREFIX}__header` as const;

/**
 * Classe CSS "legacy" pour l'en-tête (compatibilité).
 */
const CLASS_RC_HEADER = 'header';

/**
 * Ancienne classe CSS pour l'en-tête (pour rétrocompatibilité).
 */
const CLASS_RC_HEADER_OLD = 'old-header' as const;

/**
 * Classe CSS pour le corps de la colonne.
 */
const CLASS_BODY = `${CLASS_PREFIX}__body` as const;

/**
 * Classe CSS pour le pied de page de la colonne.
 */
const CLASS_FOOTER = `${CLASS_PREFIX}__footer` as const;

/**
 * Classe CSS "legacy" pour le pied de page (compatibilité).
 */
const CLASS_RC_FOOTER = 'footer';

/**
 * Classe CSS indiquant qu'un élément provient d'un slot.
 */
const CLASS_FROM_SLOT = 'from-slot';

/**
 * Préfixe pour les classes CSS de contenu.
 */
const CLASS_CONTENT_PREFIX = CLASS_PREFIX;

/**
 * Suffixe pour les classes CSS de contenu.
 */
const CLASS_CONTENT_POSTFIX = 'content';

/**
 * Classe CSS pour le contenu de l'en-tête.
 */
const CLASS_CONTENT_HEADER =
	`${CLASS_CONTENT_PREFIX}__header__${CLASS_CONTENT_POSTFIX}` as const;

/**
 * Classe CSS pour le contenu du corps.
 */
const CLASS_CONTENT_BODY =
	`${CLASS_CONTENT_PREFIX}__body__${CLASS_CONTENT_POSTFIX}` as const;

/**
 * Classe CSS pour le contenu du pied de page.
 */
const CLASS_CONTENT_FOOTER =
	`${CLASS_CONTENT_PREFIX}__footer__${CLASS_CONTENT_POSTFIX}` as const;

/**
 * Nom du slot pour l'en-tête.
 */
const SLOT_HEADER = 'header';

/**
 * Nom du slot pour le pied de page.
 */
const SLOT_FOOTER = 'footer';

/**
 * Nom de l'attribut de données pour conserver le corps.
 */
export const DATA_KEEP_BODY = 'keep-body';

/**
 * Regroupe les différentes classes CSS utilisées par le composant.
 */
export const CLASSES = {
	HOST: TAG_COLUMN,
	HEADER: {
		MAIN: CLASS_HEADER,
		RC: CLASS_RC_HEADER,
		OLD: CLASS_RC_HEADER_OLD,
	},
	BODY: CLASS_BODY,
	FOOTER: {
		MAIN: CLASS_FOOTER,
		RC: CLASS_RC_FOOTER,
	},
	CONTENT_PREFIX: TAG_COLUMN,
	FROM_SLOT: CLASS_FROM_SLOT,
	CONTENT: {
		HEADER: CLASS_CONTENT_HEADER,
		BODY: CLASS_CONTENT_BODY,
		FOOTER: CLASS_CONTENT_FOOTER,
	},
} as const;

/**
 * Regroupe les noms de slots utilisés.
 */
export const SLOTS = {
	HEADER: SLOT_HEADER,
	FOOTER: SLOT_FOOTER,
} as const;

/**
 * Regroupe les noms d'attributs utilisés.
 */
export const ATTRIBUTES = {
	TYPE: ATTR_TYPE,
	DATA: {
		KEEP_BODY: DATA_KEEP_BODY,
	},
} as const;
